module.exports = "<div class=\"configuration-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    Notes  for {{ vm.object.name }}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/product_conf/templates/notes.html
// module id = 766
// module chunks = 0